import React from "react";
import './ExclusiveDesc.css';

function ExclusiveDesc(){
    return (
        <div className="ExclusiveDescContainer">
            <div>
                Back
            </div>

            <img/>

            <div>

            </div>

            <div>
                <div>ABOUT</div>
                <div>TRACK</div>
                <div>TERMS</div>
            </div>

            <div>
                <div>

                </div>

                <div>
                    
                </div>
            </div>
        </div>
    );
}

export default ExclusiveDesc;